import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  card: {
    width: '100%',
  },
}));
